import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'
import imageBanner from './img/banner.png'
import imageTable from './img/table.jpg'
import imageCertificate1 from './img/certificate-1.jpg'
import imageCertificate2 from './img/certificate-2.jpg'

export const ceTitanV3: ProductProps = {
  tag: ProductTag.PV,
  category: ProductCategory.DistributedPVStorageSystems,
  pathName: 'ce-titan-v3',
  banner: imageBanner,
  title: 'CE-Titan V3',
  specImages: [imageTable],
  certificateImages: [imageCertificate1, imageCertificate2],
}
